export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              关于本站
            </h2>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-10">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
              <div className="flex-1">
                <p className="text-foreground-700 leading-relaxed mb-4">
                  丫丫影院创立于2021年，是国内领先的免费高清影视在线观看平台。五年来，我们始终坚持"让每个人都能轻松享受高品质影视内容"的初心，持续为用户提供最新、最全、最流畅的观影服务。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  平台汇聚了超过十万部正版授权与公共领域影视作品，涵盖电影、电视剧、综艺节目、动漫番剧、纪录片等多种内容形态。每日同步更新最新院线影片与热播剧集，确保用户第一时间看到想看的内容。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-6">
                  我们采用全球CDN加速与智能转码技术，支持从流畅到4K多种清晰度自适应切换，无论您使用什么设备、身处何种网络环境，都能获得稳定流畅的观影体验。丫丫影院承诺：永久免费、无隐藏收费、无强制注册。
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {[
                    { num: '5', label: '年运营经验' },
                    { num: '10万+', label: '影视作品' },
                    { num: '500万+', label: '月活用户' },
                    { num: '99.9%', label: '服务可用率' },
                  ].map((item) => (
                    <div key={item.label} className="text-center p-4 rounded-xl bg-primary-50">
                      <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                        {item.num}
                      </div>
                      <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:w-72 shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20comfortable%20sofa%20and%20large%20screen%20displaying%20cinematic%20content%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20film%20posters%20on%20wall%2C%20inviting%20and%20relaxed%20mood&width=400&height=500&seq=about-movie-2026&orientation=portrait"
                  alt="丫丫影院观影体验"
                  className="w-full rounded-xl object-cover aspect-[4/5]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}